import React, { useEffect, useMemo, useState } from 'react';
import { useI18n } from '../i18n';
import './TonyteLoadingScreen.web.css';

const loginLogo = require('../assets/login_logo.png');

interface Props {
  message?: string;
}

type LoadingStage = 'initial' | 'almost' | 'still';

const withoutTrailingDots = (value: string) => value.replace(/[.\u2026]+\s*$/, '');

export default function TonyteLoadingScreen({ message }: Props) {
  const { t } = useI18n();
  const [stage, setStage] = useState<LoadingStage>('initial');

  useEffect(() => {
    const almostTimer = window.setTimeout(() => setStage('almost'), 5000);
    const stillTimer = window.setTimeout(() => setStage('still'), 10000);
    return () => {
      window.clearTimeout(almostTimer);
      window.clearTimeout(stillTimer);
    };
  }, []);

  const status = useMemo(() => {
    if (stage === 'almost') return t('common.almostThere');
    if (stage === 'still') return t('common.stillGettingThingsReady');
    return message || t('common.findingYourVibe');
  }, [message, stage, t]);

  return (
    <div className="tonyte-web-loader" role="status" aria-live="polite" aria-label={status}>
      <div className="tonyte-web-loader__background" aria-hidden="true">
        <span className="tonyte-web-loader__wash tonyte-web-loader__wash--orange" />
        <span className="tonyte-web-loader__wash tonyte-web-loader__wash--purple" />
        {Array.from({ length: 7 }, (_, index) => (
          <span key={index} className={`tonyte-web-loader__star tonyte-web-loader__star--${index + 1}`} />
        ))}
      </div>

      <div className="tonyte-web-loader__content">
        <div className="tonyte-web-loader__logo-stage" aria-hidden="true">
          <span className="tonyte-web-loader__aura tonyte-web-loader__aura--orange" />
          <span className="tonyte-web-loader__aura tonyte-web-loader__aura--purple" />
          <img className="tonyte-web-loader__logo" src={loginLogo} alt="" />
        </div>

        <div className="tonyte-web-loader__message">
          <span key={stage} className="tonyte-web-loader__message-copy">{withoutTrailingDots(status)}</span>
          <span className="tonyte-web-loader__message-dots" aria-hidden="true">
            <span>.</span><span>.</span><span>.</span>
          </span>
        </div>

        <div className="tonyte-web-loader__activity" aria-hidden="true">
          <span /><span /><span />
        </div>
      </div>
    </div>
  );
}
